<script setup lang="ts">
import { computed } from 'vue';
import GaiaText from './GaiaText.vue';

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  /** Characters shown before the text is clipped. */
  max: {
    type: Number,
    required: true,
  },
});

const clipped = computed(() => props.text.length > props.max);
</script>

<template>
  <!-- A table cell's long text (a prompt, a clause), clipped with the whole text in a
       tooltip. Only clipped text gets one: on short text it would just repeat the cell. -->
  <n-tooltip v-if="clipped" placement="top" :style="{ maxWidth: '400px' }">
    <template #trigger>
      <gaia-text size="dense" tone="tertiary" style="cursor: help">
        {{ `${text.slice(0, max)}…` }}
      </gaia-text>
    </template>
    <div style="white-space: pre-wrap; word-break: break-word">{{ text }}</div>
  </n-tooltip>
  <gaia-text v-else size="dense" tone="tertiary">{{ text }}</gaia-text>
</template>
